import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-report-header',
  templateUrl: './report-header.component.html',
  styles: [],
})
export class ReportHeaderComponent {
  @Input() routeName: string;
}
